import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../services/data.service';
import { EnvironmentService } from '../../services/environment.service';
import { EFDataService } from '../../services/ef-data.service';

@Component({
    selector: 'app-pg-slug-editor',
    templateUrl: './pg-slug-editor.component.html',
    styleUrls: ['./pg-slug-editor.component.scss'],
    standalone: false
})
export class PgSlugEditorComponent implements OnInit, OnChanges, OnDestroy {

    @Input() resourceId:any;
    @Input() elementId:any;

    @Input() elementData:any;

    @Output() slugChange = new EventEmitter<string>()

    @Input() readonly:boolean;

    elementURL:string = null;
    hasURLQR = false;

    constructor(private dataService:DataService, private environmentService:EnvironmentService, private modalService:NgbModal, private efDataService:EFDataService) { }

    ngOnInit(): void {
    }

    ngOnChanges() {
        this._handleChanges();
    }

    ngOnDestroy(): void {
        URL.revokeObjectURL(this._elementURLQRCodeObjectURL)
    }

    private _handleChanges() {
        this.elementURL = null;
        this.hasURLQR = false;

        if(this.elementData != null && this.elementId != null && !this.dataService.isDraftId(this.elementId)) {
            if(this.environmentService.getApplicationURL('Totem') != null) {
                if(this.resourceId == 'TotemEnvironment' && this.elementData.pid != null) {
                    this.elementURL = this.environmentService.getApplicationURL('Totem') + '/' + this.elementData.pid
                }
            }

            if(this.environmentService.getApplicationURL('ExperienceFinder') != null) {
                if(this.resourceId == 'FinderEnvironment' && this.elementData.pid != null) {
                    this.elementURL = this.environmentService.getApplicationURL('ExperienceFinder') + '/' + this.elementData.pid
                }
                else if(this.efDataService.isExperienceFinderResource(this.resourceId)) {
                    this.elementURL = this.environmentService.getApplicationURL('ExperienceFinder') + '/product/' + this.efDataService.normalizeResourceName(this.resourceId) + '/' + (this.elementData.slug || this.elementId)
                    this.hasURLQR = true;
                } 
            }
        }
    }

    hasSlug() {
        return this.elementData?.slug != null;
    }

    @ViewChild('elementURLQRCode') elementURLQRCode:ElementRef;

    private _elementURLQRCodeObjectURL:string = null;

    viewElementURLQR() {
        URL.revokeObjectURL(this._elementURLQRCodeObjectURL)

        let _canvas:HTMLCanvasElement = (this.elementURLQRCode.nativeElement as HTMLElement).getElementsByTagName('canvas')[0];

        if(_canvas != null) {
            _canvas.toBlob((blob) => {
                this._elementURLQRCodeObjectURL = URL.createObjectURL(blob)
                window.open(this._elementURLQRCodeObjectURL);
            })
        }
    }

    @ViewChild('editModal') editModal:ElementRef;

    private _editModalRef:NgbModalRef = null;

    editModalValue:string = null;
    editModalSaving = false;

    openEditModal() {
        this.editModalSaveError = null;
        this.editModalValue = this.elementData.slug;
        this._editModalRef = this.modalService.open(this.editModal)
    }

    editModalDismiss() {
        this._editModalRef.dismiss()
    }

    isEditModalValueValid() {
        return /^[a-z|\d|-]+$/.test(this.editModalValue) && !/^\d+$/.test(this.editModalValue);
    }

    editModalCanSave() {
        return !this.editModalSaving && this.editModalValue != this.elementData.slug && this.isEditModalValueValid()
    }

    editModalSaveError = null;

    editModalDoSave() {
        if(this.editModalCanSave()) {
            this.editModalSaveError = null;
            this.editModalSaving = true;
    
            this.dataService.setElementSlug(this.resourceId, this.elementId, this.editModalValue).subscribe((data) => {
                this.editModalSaving = false;
                
                if(data != null) {
                    this.editModalDismiss();
        
                    this.elementData.slug = data;
                    this.slugChange.emit(this.elementData.slug)
        
                    this._handleChanges()
                }
            }, (error) => {
                if(error == 'slug-taken') this.editModalSaveError = true;
                this.editModalSaving = false;
            })
        }
    }
}
